import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function SelectStatus({
  label,
  placeholder,
  name,
  value,
  onChange,
  onBlur,
  errorFormik,
  helperText,
  error,
  disable,
  sx,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);

  const statuses = [
    { id: 1, status: "Active", value: "1" },
    { id: 2, status: "Inactive", value: "0" },
  ];

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 100);
  }, [value]);

  const [selectedStatus, setSelectedStatus] = useState(
    statuses?.find((status) => status?.value === value) || null
  );

  useEffect(() => {
    setSelectedStatus(
      statuses?.find((status) => status?.value === value) || null
    );
  }, [value]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (newValue) => {
    setAnchorEl(null);
    if (newValue) {
      onChange?.(name, newValue?.value || "");
      setSelectedStatus(newValue);
    }
  };

  const handleClear = () => {
    onChange?.(name, ""); // Clear the value
    setSelectedStatus(null);
  };

  return (
    <Box>
      <TextField
        label={
          // eslint-disable-next-line no-nested-ternary
          error
            ? `${label || placeholder} - ${error}`
            : disable
            ? `${label || placeholder} - Not Applicable`
            : label
        }
        placeholder={
          // eslint-disable-next-line no-nested-ternary
          error
            ? `${placeholder} - ${error}`
            : disable
            ? `${placeholder} - Not Applicable`
            : placeholder
        }
        name={name}
        variant="outlined"
        size="small"
        disabled={error || disable}
        value={selectedStatus && value ? selectedStatus.status : ""}
        onClick={handleClick}
        onBlur={onBlur}
        error={errorFormik}
        helperText={helperText}
        sx={sx}
        InputProps={{
          endAdornment: (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              {loading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                <>
                  {selectedStatus && (
                    <IconButton edge="end" onClick={handleClear}>
                      <CloseIcon />
                    </IconButton>
                  )}
                  {!disable && !error && (
                    <IconButton edge="end" onClick={handleClick}>
                      <ArrowDropDownIcon />
                    </IconButton>
                  )}
                </>
              )}
            </>
          ),
        }}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose(null)}
      >
        {statuses.map((status) => (
          <MenuItem
            sx={{ width: "100%" }}
            key={status.id}
            onClick={() => handleClose(status)}
          >
            {status.status}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
